module.exports = __webpack_public_path__ + "static/SSMA_logo_new-b04388cd5c3ef25429670702c144729c.svg";